import React from 'react';

import { Badge } from '@economic/taco';
import { InvoicingMessage, InvoicingMessageType } from '../../invoices/book-and-send/types';
import { useLocalization, t } from '../../../../../shared/components/l10n/l10n';

function getBadgeState(messageType: InvoicingMessageType) {
    switch (messageType) {
        case InvoicingMessageType.Error:
            return 'error';
        case InvoicingMessageType.Warning:
            return 'warning';
        default:
            return undefined;
    }
}

function getBadgeLabel(messageType: InvoicingMessageType) {
    switch (messageType) {
        case InvoicingMessageType.Error:
            return t`SHARED_FORM_TOOLTIP_BADGE_ERROR`;
        case InvoicingMessageType.Warning:
            return t`SHARED_FORM_TOOLTIP_BADGE_WARNING`;
        default:
            return t`SHARED_FORM_TOOLTIP_BADGE_INFORMATION`;
    }
}

export function DisplayMessages({ messages }: { messages: InvoicingMessage[] }) {
    const textsLoading = useLocalization(textIds);

    if (textsLoading || !messages) {
        return null;
    }

    messages.sort((a, b) => {
        if (a.type < b.type) return 1;
        if (a.type > b.type) return -1;
        return 0;
    });

    return (
        <ul className="book-and-send-dialog__messages__list">
            {messages.map((message, idx) => (
                <li key={idx}>
                    <Badge aria-label={getBadgeLabel(message.type)} state={getBadgeState(message.type)}>
                        !
                    </Badge>
                    {message.message}
                </li>
            ))}
        </ul>
    );
}

const textIds = ['SHARED_FORM_TOOLTIP_BADGE_ERROR', 'SHARED_FORM_TOOLTIP_BADGE_WARNING', 'SHARED_FORM_TOOLTIP_BADGE_INFORMATION'];
